// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfq_a"};